/* global axios */
import ApiClient from './ApiClient';

class UserActivityReportsAPI extends ApiClient {
  constructor() {
    super('user_activity_reports', { accountScoped: true });
  }

  getAnalytics(params = {}) {
    return axios.get(`${this.url}`, { params });
  }

  getPauseSummary(params = {}) {
    return axios.get(`${this.url}/pause_summary`, { params });
  }

  getAvailabilityTransitions(params = {}) {
    return axios.get(`${this.url}/availability_transitions`, { params });
  }

  getUserRankings(params = {}) {
    return axios.get(`${this.url}/user_rankings`, { params });
  }
}

export default new UserActivityReportsAPI();
